import { Component, OnDestroy, OnInit, TemplateRef } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { BsModalService } from "ngx-bootstrap/modal";
import * as _ from "lodash";
import { ImageService } from "../../../imageService";
import { PromotionService } from "../../../../common/services/Promotion.service";
import { UploadService } from "../../../../common/services/Upload.service";

declare var $: any;

@Component({
  selector: "gift",
  templateUrl: "./gift.component.html",
  styleUrls: ["./gift.css"],
  providers: [PromotionService, BsModalService]
})
export class GiftComponent implements OnInit {
  no_image = "assets/images/no-image.png";
  public list: any = [];
  public modalRef2 : any;

  public page_size: number = 10;
  public currentPage: number = 1;
  public totalItem: number = 0;
  public totalPage: number = 0;

  public modelFilter: any = {};
  public model: any = {};
  public image_show: any;

  constructor(
    private promotionService: PromotionService,
    private modalService: BsModalService,
    private toastr: ToastrService,
    private imageService: ImageService,
    private upload: UploadService
  ) { }

  ngOnInit() {
    this.loadData();
  }

  loadData(request: any = {}, sort: any = {}) {
    this.list = [];
    request.offset =
      this.page_size * (this.currentPage <= 0 ? 0 : this.currentPage - 1);
    request.limit = this.page_size;
    if (Object.keys(sort).length == 2) {
      request["sort_by"] = sort.field + ":" + sort.typeSort;
    }
    this.promotionService
      .listGift(request)
      .toPromise()
      .then(
        res => {
          if (res.status == 200) {
            this.list = res.data.list;

            for (let i = 0; i < this.list.length; i++) {
              this.list[i].image = this.imageService.readSrcImage(
                this.list[i].image,
                "thumb_medium"
              );
            }
            this.totalItem = res.data.total;
            var pageString = (this.totalItem / this.page_size).toString();
            var pageSplit = pageString.split(".");
            var last: any;
            var totalpage = parseInt(pageSplit[0]);
            if (pageSplit.length > 1) {
              last = pageSplit[1];
              if (parseInt(last) > 0) {
                totalpage++;
              }
            }
            this.totalPage = totalpage;
            if(this.totalItem == 0) {
              this.model = null;
            }else 
            this.viewDetail(this.list[0]);
          } else {
            this.list = [];
          }
        },
        err => {
          this.list = [];
        }
      );
  }


  submitFilter() {
    this.loadData(this.modelFilter);
  }


  viewDetail(gift) {
    this.model = gift;
    this.image_show = this.imageService.readSrcImage(gift.image, 'thumb_medium');
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef2 = this.modalService.show(template);
  }

  delete(id) {
    let payload = {status : 0};
    this.promotionService.updateGift(id, payload).subscribe(res => {
      if (!res.error && res.status == 200) {
        this.toastr.success("Xoá thành công", "", {
          timeOut: 4000,
          positionClass: "toast-bottom-right"
        });
        this.loadData();
        this.modalRef2.hide();
      } else {
        this.toastr.error("Xoá không thành công", "", {
          timeOut: 4000,
          positionClass: "toast-bottom-right"
        });
        this.modalRef2.hide();
      }
    });
  }

  uploadFile(event: any) {
    var fileUpload: any = [];
    var file: any;
    file = event.srcElement.files[0];
    if (file.size > 1024 * 1024 * 3) {
      this.toastr.error(
        "Kích thước hình ảnh " +
        file.name +
        " đã vượt quá 3MB, vui lòng chọn ảnh khác",
        "",
        {
          timeOut: 4000,
          positionClass: "toast-bottom-right"
        }
      );
    } else {
      fileUpload.push(file);
    }
    Promise.all(
      fileUpload.map(file => {
        return this.upload.upload(file).then((uploaded: any) => {
          return uploaded;
        });
      })
    ).then((upload: any) => {
      upload.forEach(dta => {
        this.model.image = dta.prefix;
        this.image_show = this.imageService.readSrcImage(dta.prefix, 'thumb_medium');
      });
    });
  }


  save() {
    console.log(this.model);
    if (!this.model.name) {
      this.toastr.error("Món quà chưa có tên", "", {
        timeOut: 4000,
        positionClass: "toast-bottom-right"
      });
    }else  if (!this.model.image) {
      this.toastr.error("Thiếu hình ảnh món quà", "", {
        timeOut: 4000,
        positionClass: "toast-bottom-right"
      });
    }else if (!this.model.point) {
      this.toastr.error("Thiếu số điểm đổi thưởng món quà", "", {
        timeOut: 4000,
        positionClass: "toast-bottom-right"
      });
    } else {
      if(this.model.id) {
        let payload = {
          name : this.model.name,
          image: this.model.image,
          point : this.model.point
        }
        this.promotionService.updateGift(this.model.id, payload).subscribe(res => {
          if (!res.error && res.status == 200) {
            this.toastr.success("Cập nhật thành công", "", {
              timeOut: 4000,
              positionClass: "toast-bottom-right"
            });
            this.viewDetail(this.model);
          } else {
            this.toastr.error("Cập nhật không thành công", "", {
              timeOut: 4000,
              positionClass: "toast-bottom-right"
            });
          }
        });
      }else {
        this.promotionService.createGift(this.model).subscribe(res => {
          if (!res.error && res.status == 200) {
            this.toastr.success("Tạo mới thành công", "", {
              timeOut: 4000,
              positionClass: "toast-bottom-right"
            });
            this.loadData();
            let payload = _.assign({},this.model);
            payload.id = res.data[0]
            this.viewDetail(payload);
          } else {
            this.toastr.error("Tạo mới không thành công", "", {
              timeOut: 4000,
              positionClass: "toast-bottom-right"
            });
          }
        });
      }
    }
  }

  setPage(page: number) {
    if (page <= this.totalPage) {
      if (page < 1) {
        page = 1;
      }
      if (page != this.currentPage) {
        this.currentPage = page;
        this.loadData();
      }
    } else {
      page = this.totalPage;
      $("#inputPage").val(page);
      this.toastr.warning("Số trang tối đa hiện tại là " + page, "", {
        timeOut: 4000,
        positionClass: "toast-bottom-right"
      });
      if (page <= this.totalPage) {
        //this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
        if (page < 1) {
          page = 1;
        }
        if (page != this.currentPage) {
          this.currentPage = page;
          this.loadData();
        }
      }
    }
  }

  goPage2(toPage: any) {
    toPage = parseInt(toPage);
    if (toPage && toPage > 0) {
      this.setPage(toPage);
    }
  }

  _keyPress(event: any) {
    if (event.charCode !== 0) {
      const pattern = /[0-9]/;
      const inputChar = String.fromCharCode(event.charCode);

      if (!pattern.test(inputChar)) {
        // invalid character, prevent input
        event.preventDefault();
      }
    }
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/gift/gift.component.ts